import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('StarterPackClaim').create(({ theme }) => ({
  root: {
    width: '100%',
    height: '100%',
    padding: '8px',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    gap: '16px',

    '&[data-rarity="Legendary"]': {
      '::before': {
        backgroundColor: theme.colors.borders.legendary,
        content: '""',
        position: 'fixed',
        zIndex: '10',
        width: '60%',
        // height: '30px',
        aspectRatio: '1/1',
        top: '-10%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '9999px',
        filter: 'blur(135px)',
      },

      '::after': {
        backgroundColor: theme.colors.borders.legendary,
        content: '""',
        position: 'fixed',
        zIndex: '10',
        width: '60%',
        // height: '30px',
        aspectRatio: '1/1',
        bottom: '-55%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '9999px',
        filter: 'blur(125px)',
      },
    },

    '&[data-rarity="Epic"]': {
      '::before': {
        backgroundColor: theme.colors.borders.epic,
        content: '""',
        position: 'fixed',
        zIndex: '10',
        width: '60%',
        // height: '30px',
        aspectRatio: '1/1',
        top: '-10%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '9999px',
        filter: 'blur(135px)',
      },

      '::after': {
        backgroundColor: theme.colors.borders.epic,
        content: '""',
        position: 'fixed',
        zIndex: '10',
        width: '60%',
        // height: '30px',
        aspectRatio: '1/1',
        bottom: '-55%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '9999px',
        filter: 'blur(125px)',
      },
    },

    '&[data-rarity="Rare"]': {
      '::before': {
        backgroundColor: theme.colors.borders.rare,
        content: '""',
        position: 'fixed',
        zIndex: '10',
        width: '60%',
        // height: '30px',
        aspectRatio: '1/1',
        top: '-10%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '9999px',
        filter: 'blur(135px)',
      },

      '::after': {
        backgroundColor: theme.colors.borders.rare,
        content: '""',
        position: 'fixed',
        zIndex: '10',
        width: '60%',
        // height: '30px',
        aspectRatio: '1/1',
        bottom: '-55%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '9999px',
        filter: 'blur(125px)',
      },
    },
  },

  button: {
    width: '95%',
    height: '52px',
  },

  heading: {
    fontSize: '20px',
    textAlign: 'center',
    fontWeight: 450,
    color: 'white',
  },
  subHeading: {
    fontSize: '14px',
    textAlign: 'center',
    fontWeight: 350,
    color: theme.colors.text.secondary,
  },

  starterPackList: {
    marginTop: '72px',
    display: 'flex',
    gap: '32px',
    flexWrap: 'wrap',
    width: '100%',
    justifyContent: 'center',
  },
}))
